import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { DialogComponent } from '../../../../shared/dialog/dialog.component';
import { UserCache } from '../../services/user/user.cache';
import { EstimateComopnent } from '../estimate.component';
import { EstimateTotalService } from '../../services/estimate-total.service';

@Component({
  selector: 'material-estimate',
  templateUrl: './material-estimate.component.html'
})
export class MaterialEstimateComponent extends EstimateComopnent {
  @Input() isReadOnly: boolean = false;
  @Output() remove = new EventEmitter<void>();
  
  protected readonly _destroying$ = new Subject<void>();
  private confirmationDialog: MatDialogRef<DialogComponent>;

  public taxPercentage: number = 0;

  constructor(private userCache: UserCache,
              private dialog: MatDialog) {
    super();
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      'price': new UntypedFormControl("", [Validators.required, Validators.min(0), Validators.max(99999.99)]),
      'quantity': new UntypedFormControl("", [Validators.required, Validators.min(0), Validators.max(999)]),
      'description': new FormControl("", [Validators.required, Validators.maxLength(100)])
    });

    
    this.userCache.updated
        .pipe(takeUntil(this._destroying$))
        .subscribe(() => {
          this.taxPercentage = this.userCache.selectedRepairFacility?.partTaxRate ?? 0;
        });
    this.taxPercentage = this.userCache.selectedRepairFacility?.partTaxRate ?? 0;

    // Trigger recalculation when form values change
    this.form.valueChanges
      .pipe(takeUntil(this._destroying$))
      .subscribe(() => {
        EstimateTotalService.triggerGlobalRecalculation();
      });
  }
	ngOnDestroy(): void {
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}

  public override get total(): number {
    return (this.form.get('price').value ?? 0) * (this.form.get('quantity').value ?? 0);
  }

  public override get totalTax(): number {
    return this.total * this.taxPercentage / 100;
  }

  public removeMaterial(): void {
    this.confirmationDialog = this.dialog.open(DialogComponent, {
      data: {
        title: 'Delete Material',
        bodyText: 'Are you sure you want to delete this material?',
        cancelButtonText: 'Cancel',
        confirmationButtonText: 'Yes, Delete'
      }
    });

    this.confirmationDialog.afterClosed().subscribe(result => {
      if (result) {
        this.remove.emit();
        // Trigger global recalculation when line item is removed
        EstimateTotalService.triggerGlobalRecalculation();
      }
    });
  }

  /**
   * Handle price input event - trigger recalculation as user types
   */
  public onPriceInput(): void {
    EstimateTotalService.triggerGlobalRecalculation();
  }

  /**
   * Handle quantity input event - trigger recalculation as user types
   */
  public onQuantityInput(): void {
    EstimateTotalService.triggerGlobalRecalculation();
  }
}
